import React from 'react';
import { off, on } from '../utils/events';
import { useRafState } from './useRafState';

export interface State {
  x: number;
  y: number;
}

export const useScroll = (ref: React.RefObject<HTMLElement>): State => {
  const [state, setState] = useRafState<State>({
    x: 0,
    y: 0,
  });

  React.useEffect(() => {
    const handler = () => {
      if (ref.current) {
        setState({
          x: ref.current.scrollLeft,
          y: ref.current.scrollTop,
        });
      }
    };

    if (ref.current) {
      on(ref.current, 'scroll', handler, {
        capture: false,
        passive: true,
      });
    }

    return () => {
      if (ref.current) {
        off(ref.current, 'scroll', handler);
      }
    };
  }, [ref, setState]);

  return state;
};
